import React from 'react';
import { connect } from "react-redux";
import {toggleShowJobBoardFiltersPopup} from "./JobBoardFiltersActions";


const JobBoardFiltersButton = (props) => {

  const {filters, showJobBoardFiltersPopup, toggleShowJobBoardFiltersPopup} = props;

  const handleButtonClick = () => {
    return toggleShowJobBoardFiltersPopup(!showJobBoardFiltersPopup)
  }

  return (
    <button className="jb-filters__button" onClick={handleButtonClick}>
      {filters.length ? <span className="jb-filters__button-count">{filters.length}</span> : null}
    </button>
  )
};

const mapStateToProps = (store) => {
  const {filters, showJobBoardFiltersPopup} = store.jobBoard;
  return {
    showJobBoardFiltersPopup,
    filters
  };
};

const mapDispatchToProps = {
  toggleShowJobBoardFiltersPopup
};

export default connect(mapStateToProps, mapDispatchToProps)(JobBoardFiltersButton);
